const vendors = JSON.parse(localStorage.getItem("vendors"));
const initialState = {
    usersVendors: vendors ?? [],
    allVendors: [],
};

const usersVendors = (state = initialState, action) => {
    switch (action.type) {
        case "SET_USER_VENDORS":
            return {
                ...state,
                usersVendors: action.payload,
            };
        case "SET_ALL_VENDORS":
            return {
                ...state,
                allVendors: action.payload,
            };
        default:
            return state;
    }
};
export default usersVendors;
